import template from './sourceTable.html';
import controller from './sourceTable.controller';

let sourceTableComponent = {
  restrict: 'E',
  bindings: {
    row: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default sourceTableComponent;



// WEBPACK FOOTER //
// ./app/components/sourceTable/sourceTable.component.js